import * as mobxReact from 'mobx-react';
import * as React from 'react';
import * as IoC from 'typescript-ioc';
import { injectIntl, IntlShape } from 'react-intl';
import { AuthAggregateProvider } from '../../domain/auth/implementations/auth-aggregate-provider';
import { LocalStorageService } from '../../infrastructure/implementations/local-storage-service';
import { ILocalStorageService } from '../../infrastructure/local-storage-service';
import { CLONED_CONNECTION } from '../../constants/common.constants';
import OptionsButton from '../global/options-button/options-button';
import UserIconSvg from '../../images/svg/icons8-male-user';
import './account-button.scss';


interface IProps {
    intl: IntlShape;
}

const AccountButton = mobxReact.observer(injectIntl((props: IProps) => {
    const { intl } = props;

    const authProvider = IoC.Container.get<AuthAggregateProvider>(AuthAggregateProvider);
    const localStorageService = IoC.Container.get<ILocalStorageService>(LocalStorageService);

    const logoutAction = authProvider.get().logout;
    const isLoggedIn = authProvider.get().isAuthenticated();
    const handleLogout = () => {
        logoutAction();
        localStorageService.deleteLocalStorageValue(CLONED_CONNECTION);
    };
    const options = [
        isLoggedIn && {
            label: intl.formatMessage(
                {
                    id: 'oe.common.signOut',
                    description: 'Sign out of account',
                    defaultMessage: 'Sign Out',
                }
            ),
            action: handleLogout
        },
    ].filter(Boolean);

    return <OptionsButton
        className='account-button'
        options={options}
        icon={UserIconSvg}
        isIconButton
    />;
}));

export default AccountButton;